{
  "tagCreateDialog": {
    "label": "Private",
    "required": "Enter a tag name.",
    "max": "The tag name must be 10 characters or fewer.",
    "required2": "Select a visibility status.",
    "enqueueSnackbar": "Tag created",
    "enqueueSnackbar2": "The tag couldn't be created.",
    "text": "Creating...",
    "text2": "Create",
    "title": "Create tag",
    "label2": "Tag name",
    "label3": "Visibility",
    "text3": "Private tags are visible only to you."
  },
  "tagFilterBar": {
    "placeholder": "Search by tag name",
    "button": "Create tag"
  },
  "tagTable": {
    "label": "Tag name",
    "label2": "Status",
    "text": "Public",
    "text2": "Private"
  },
  "tagTableHeader": {
    "text": " tags"
  },
  "tagViewLayout": {
    "text": "Deleting...",
    "title": "Delete tag",
    "text2": "This action can't be undone. Continue?"
  },
  "useTagViewState": {
    "enqueueSnackbar": "Tag deleted",
    "enqueueSnackbar2": "The tag couldn't be deleted."
  },
  "tag": {
    "title": "Tag management"
  }
}
